var exports = {
  "uW": "x2b2fbebb--f3bb9c--section",
  "VA": "x2b2fbebb--f3bb9c--subtitle",
  "VQ": "x2b2fbebb--f3bb9c--ratings",
  "O0": "x2b2fbebb--f3bb9c--rating",
};

module.exports = exports;
